import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeContext } from './contexts/theme';
import Navbar from './components/Navbar/Navbar';
import About from './components/About/About';
import CareerServices from './components/CareerServices/CareerServices';
import TechCourses from './components/TechCourses/TechCourses';
import WebServices from './components/WebServices/WebServices';
import TravelServices from './components/TravelServices/TravelServices';
import Reviews from './components/Reviews/Reviews';
import AppDownload from './components/AppDownload/AppDownload';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Projects from './pages/Projects/Projects';
import Contact from './pages/Contact/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import Chatbot from './components/Chatbot/Chatbot';
import AboutPage from './components/AboutPage/AboutPage';

const App = () => {
  const [{ themeName }] = useContext(ThemeContext);

  return (
    <div id="top" className={`${themeName} font-poppins min-h-screen transition-colors duration-300 bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 overflow-x-hidden max-w-full`}>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
           
            <main className="pt-6 md:pt-8 px-4 sm:px-6 md:px-0">
              <About />
              <CareerServices />
              <TechCourses />
              <WebServices />
              <TravelServices />
              <Reviews />
              <AppDownload />
              <FAQ />
            </main>
          }
        />

        <Route path="/projects" element={<div className="px-4 md:px-0"><Projects /></div>} />
        <Route path="/contact" element={<div className="px-4 md:px-0"><Contact /></div>} />
        <Route path="/about" element={<div className="px-4 md:px-0"><AboutPage /></div>} />
        <Route path="/terms-of-service" element={<div className="px-4 md:px-0"><TermsOfService /></div>} />
        <Route path="/privacy-policy" element={<div className="px-4 md:px-0"><PrivacyPolicy /></div>} />
        <Route path="/refund-policy" element={<div className="px-4 md:px-0"><RefundPolicy /></div>} />
      </Routes>
      <Footer />
      <ScrollToTop />
      <Chatbot />
    </div>
  );
};

export default App;